import Phaser from "phaser";
import { createProceduralTextures } from "../views/procedural-textures";
import { createCastleApproachTextures } from "../views/castle-approach-textures";
import { loadSave } from "../systems/save";
export class PreloadScene extends Phaser.Scene {
  constructor() {
    super("Preload");
  }
  create(): void {
    document.body.classList.toggle("high-contrast", loadSave().settings.highContrast);
    createCastleApproachTextures(this);
    createProceduralTextures(this);
    this.scene.start("MainMenu");
  }
}
